
import React, { useState, useRef, useEffect } from "react";
import { Input, Modal, List, Tooltip, message as antMessage } from "antd";
import EmojiPicker from "emoji-picker-react";
import { AudioOutlined, FileTextOutlined, SendOutlined, DeleteOutlined, ThunderboltOutlined } from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSelectedContact } from "../../../../../core/data/redux/slices/SelectedContactSlice";
import WhatsappTemplateModal from "../../../../common/WhatsappTemplateModal";
import api from "../../../../../core/axios/axiosInstance";
import { useSelector } from "react-redux";
import { attachMetaMessageId } from "../../../../../core/data/redux/slices/WabaChatSlice";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile } from "@ffmpeg/util";

const MessageInput = ({ onSend, disabled, activeChat, showPreview, setShowPreview, isWabaChat }) => {
  const [text, setText] = useState("");
  const location = useLocation();
  const [showEmoji, setShowEmoji] = useState(false);
  const [recording, setRecording] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  // Manual trigger state
  const [showFlowModal, setShowFlowModal] = useState(false);
  const [manualFlows, setManualFlows] = useState([]);
  const [loadingFlows, setLoadingFlows] = useState(false);
  const [triggeringFlowId, setTriggeringFlowId] = useState(null);

  const openFlowModal = async () => {
    setShowFlowModal(true);
    setLoadingFlows(true);
    try {
      const res = await api.get("/api/waba/automation/flows");
      const all = res.data?.data || [];
      setManualFlows(all.filter((f) => f.isActive && f.nodes?.some((n) => n.type === "trigger" && n.data?.triggerType === "manual")));
    } catch (_) {
      antMessage.error("Failed to load flows");
    } finally {
      setLoadingFlows(false);
    }
  };

  const triggerFlow = async (flowId) => {
    const phone = activeChat?.from;
    if (!phone) return;
    setTriggeringFlowId(flowId);
    try {
      await api.post(`/api/waba/automation/flows/${flowId}/trigger`, { phone });
      antMessage.success("Flow started!");
      setShowFlowModal(false);
    } catch (err) {
      antMessage.error(err?.response?.data?.message || "Failed to start flow");
    } finally {
      setTriggeringFlowId(null);
    }
  };




  const ffmpeg = new FFmpeg();
  const loadFFmpeg = async () => {
    if (!ffmpeg.loaded) {
      await ffmpeg.load();
    }
  };
  useEffect(() => {
    loadFFmpeg();
  }, []);


  const activeChatName = useSelector((state) => {
    const { conversations, activeChatId } = state.wabaChat;

    const chat = conversations.find(c => c.from === activeChatId);
  

    return (
      chat?.chatName ||
      chat?.originalName ||
      chat?.messages?.find(msg => msg.name)?.name ||
      chat?.from ||
      "Unknown"
    );
  });


  const inputRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const dispatch = useDispatch();

  const sendText = async () => {
    if (!text.trim()) return;
    const tempId = `tmp_${Date.now()}`;
    try {
      const payload = {
        to: activeChat.from,
        text,
        name: activeChatName
      }
      console.log(payload, "payloadpadddyload");

      onSend({ text, tempId });
      setText("");
      const response = await api.post("/api/whatsapp/send-text", payload)

      const metaMessageId = response.data.data.messages[0].id;
      console.log(activeChat.from,
        tempId,
        metaMessageId, "hjgfdxchvjbknlj");

      dispatch(
        attachMetaMessageId({
          chatId: activeChat.from,
          tempId,
          metaMessageId,
        }))
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);

      mediaRecorderRef.current = recorder;
      audioChunksRef.current = [];

      recorder.ondataavailable = (e) => audioChunksRef.current.push(e.data);
      recorder.start();
      setRecording(true);
    } catch (err) {
      console.error("Microphone access denied", err);

    }
  };

  const cancelRecording = () => {
    stopStream();
    audioChunksRef.current = [];
    setRecording(false);
  };

  const stopStream = () => {
    if (mediaRecorderRef.current?.stream) {
      mediaRecorderRef.current.stream.getTracks().forEach((track) => track.stop());
    }
  };

  // const sendRecording = () => {
  //   mediaRecorderRef.current?.stop();

  //   mediaRecorderRef.current.onstop = async () => {
  //     const audioBlob = new Blob(audioChunksRef.current, {  type: "audio/ogg;codecs=opus",});
  //     const audioFile = new File([audioBlob], "voice-note.webm", {
  //       type: "audio",
  //     });

  //     try {
  //       const tempId = `tmp_${Date.now()}`;
  //       onSend({
  //         file: audioFile,
  //         type: "audio",
  //         tempId
  //       });

  //       stopStream();
  //       setRecording(false);

  //       const response = await sendMediaMessage({
  //         file: audioFile,
  //         to: activeChat.from,
  //         name: activeChatName,
  //       });



  //       const metaMessageId = response.data.data.messages[0].id;

  //       dispatch(
  //         attachMetaMessageId({
  //           chatId: activeChat.from,
  //           tempId,
  //           metaMessageId,
  //         })
  //       );

  //     } catch (err) {
  //       console.error("Error sending audio:", err);
  //     }
  //     finally {
  //       audioChunksRef.current = [];
  //       stopStream();
  //       setRecording(false);
  //     }


  //   };
  // };
  const sendRecording = () => {
    mediaRecorderRef.current?.stop();

    mediaRecorderRef.current.onstop = async () => {
      try {
        setRecording(false);
        stopStream();

        const webmBlob = new Blob(audioChunksRef.current, {
          type: "audio/webm",
        });

        await loadFFmpeg();

        // Write file into ffmpeg FS
        await ffmpeg.writeFile("input.webm", await fetchFile(webmBlob));

        // Convert to OGG (Opus codec)
        await ffmpeg.exec([
          "-i",
          "input.webm",
          "-c:a",
          "libopus",
          "output.ogg",
        ]);

        // Read converted file
        const data = await ffmpeg.readFile("output.ogg");

        const oggBlob = new Blob([data.buffer], {
          type: "audio/ogg",
        });

        const audioFile = new File([oggBlob], "voice-note.ogg", {
          type: "audio/ogg",
        });

        const tempId = `tmp_${Date.now()}`;

        onSend({
          file: audioFile,
          type: "audio",
          tempId,
        });

        const response = await sendMediaMessage({
          file: audioFile,
          to: activeChat.from,
          name: activeChatName,
        });

        const metaMessageId = response.data.data.messages[0].id;

        dispatch(
          attachMetaMessageId({
            chatId: activeChat.from,
            tempId,
            metaMessageId,
          })
        );
      } catch (err) {
        console.error("Conversion error:", err);
      } finally {
        audioChunksRef.current = [];
      }
    };
  };



  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedFile(file);

    // create preview only for images/videos
    if (file.type.startsWith("image/") || file.type.startsWith("video/")) {
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      setPreviewUrl(null);
    }

    setShowPreview(true); // 🔥 open preview screen
    e.target.value = null;
  };


  const handleSendSelectedFile = async () => {
    if (!selectedFile) return;

    try {
      const tempId = `tmp_${Date.now()}`;

      onSend({
        file: selectedFile,
        type: getMediaType(selectedFile),
        caption: text || "",
        tempId,
      });

      const response = await sendMediaMessage({
        file: selectedFile,
        to: activeChat.from,
        name: activeChatName,
        caption: text || "",
      });

      const metaMessageId = response.data.data.messages[0].id;

      dispatch(
        attachMetaMessageId({
          chatId: activeChat.from,
          tempId,
          metaMessageId,
        })
      );
      // cleanup
      setSelectedFile(null);
      setPreviewUrl(null);
      setText("");
      setShowPreview(false);
    } catch (err) {
      console.error("Error sending media:", err);
    }
  };


  const cancelFilePreview = () => {
    setSelectedFile(null);
    setPreviewUrl(null);
    setText("");
    setShowPreview(false);
  };



  const sendMediaMessage = async ({ file, to, name, caption = "" }) => {
    const formData = new FormData();
    const mediaType = getMediaType(file);

    formData.append("file", file);
    formData.append("type", mediaType);
    formData.append("to", to);
    formData.append("name", name);

    if (caption) {
      formData.append("caption", caption);
    }

    const response = await api.post(
      "/api/whatsapp/send-message",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  };



  const getMediaType = (file) => {

    if (file.type.startsWith("image/")) return "image";
    if (file.type.startsWith("video/")) return "video";
    if (file.type.startsWith("audio/")) return "audio";
    return "document";
  };
  const isHistoryPage = location.pathname === "/whatsapp/history";
  return (
    <>
      {isWabaChat ?
        <div className="message-input-wrapper">
          {showEmoji && (
            <div className="emoji-picker-inside">
              <EmojiPicker
                onEmojiClick={(e) => {
                  const input = inputRef.current?.input;
                  if (!input) return;

                  const start = input.selectionStart || 0;
                  const end = input.selectionEnd || 0;

                  const newText = text.slice(0, start) + e.emoji + text.slice(end);
                  setText(newText);

                  requestAnimationFrame(() => {
                    input.focus();
                    const cursorPos = start + e.emoji.length;
                    input.setSelectionRange(cursorPos, cursorPos);
                  });
                }}
              />


            </div>
          )}
          {showPreview && selectedFile && (
            <div className="media-preview-container">
              {/* IMAGE PREVIEW */}
              {previewUrl && selectedFile.type.startsWith("image/") && (
                <img src={previewUrl} alt="preview" className="preview-image" />
              )}

              {/* VIDEO PREVIEW */}
              {previewUrl && selectedFile.type.startsWith("video/") && (
                <video src={previewUrl} controls className="preview-video" />
              )}

              {/* DOCUMENT / AUDIO */}
              {!previewUrl && (
                <div className="preview-document">
                  📎 {selectedFile.name}
                </div>
              )}

              {/* CAPTION INPUT */}
              <Input
                className="caption-input"
                placeholder="Add a caption"
                value={text}
                onChange={(e) => setText(e.target.value)}
              />

              {/* ACTION BUTTONS */}
              <div className="preview-actions">
                <div className="cancel-btn" onClick={cancelFilePreview} title="Cancel">
                  <DeleteOutlined />
                </div>
                <div className="send-btn" onClick={handleSendSelectedFile} title="Send">
                  <SendOutlined />
                </div>
              </div>
            </div>
          )}

          {!showPreview &&
            <div className="message-input">
              {recording ?
                <div className="recording-bar">
                  <span className="recording-dot"></span> Recording...
                </div> : (
                  <Input
                    ref={inputRef}
                    placeholder="Type a message"
                    value={text}
                    disabled={disabled}
                    onChange={(e) => setText(e.target.value)}
                    onPressEnter={sendText}
                    suffix={
                      <div className="input-actions">
                        <span onClick={() => setShowEmoji(!showEmoji)}>😊</span>
                        <label className="attach">
                          📎
                          <input type="file" onChange={handleFileSelect} hidden />
                        </label>
                        <Link
                          to="#"
                          data-bs-toggle="modal"
                          data-bs-target="#show_whatsapp_templates"
                          className="template-btn"
                          title="Templates"
                          onClick={(e) => {
                            e.preventDefault();
                            dispatch(setSelectedContact(""));
                          }}
                        >
                          <FileTextOutlined />
                        </Link>
                        <Tooltip title="Start automation flow">
                          <ThunderboltOutlined
                            style={{ cursor: "pointer", color: "#6366f1" }}
                            onClick={openFlowModal}
                          />
                        </Tooltip>
                      </div>
                    }
                  />
                )}

              {/* Recording UI */}
              {recording && (
                <div className="recording-controls">

                  <div className="recording-buttons">
                    <div className="mic-btn cancel" onClick={cancelRecording}>
                      <DeleteOutlined />
                    </div>
                    <div className="mic-btn send" onClick={sendRecording}>
                      <SendOutlined />
                    </div>
                  </div>
                </div>
              )}

              {/* WhatsApp-style send / mic buttons */}
              {!recording && (text.trim() ? (
                <div className="send-btn" onClick={sendText}>
                  <SendOutlined />
                </div>
              ) : (
                <div className="mic-btn" onMouseDown={startRecording}>
                  <AudioOutlined />
                </div>
              ))}
            </div>
          }
          <WhatsappTemplateModal from={activeChat.from} />
        </div>
        :
        <>
          <div
            className="d-flex align-items-center justify-content-between p-3 rounded mb-3 mx-3"
            style={{
              backgroundColor: "#FFF3E0",
              border: "1px solid #FFE0B2",
            }}
          >
            <div className="d-flex align-items-start gap-3">
              {/* Warning Icon */}
              <div style={{ fontSize: "20px", color: "#D32F2F" }}>
                ⚠️
              </div>

              {/* Text */}
              <div>
                <strong className="d-block">24 Hour Limit</strong>
                <span>
                  WhatsApp does not allow sending messages 24 hours after they last
                  messaged you. However, you can send them a template message.
                </span>
              </div>
            </div>

            {/* Button */}
            <button
              className="btn btn-success"
              data-bs-toggle="modal"
              data-bs-target="#show_whatsapp_templates"
              style={{ flex: "none" }}
            >
              Send Template
            </button>
          </div>
          <WhatsappTemplateModal from={activeChat.from} />
        </>
      }

      {/* Manual flow trigger modal */}
      <Modal
        title={
          <span>
            <ThunderboltOutlined style={{ color: "#6366f1", marginRight: 8 }} />
            Start Automation Flow
          </span>
        }
        open={showFlowModal}
        onCancel={() => setShowFlowModal(false)}
        footer={null}
        width={420}
      >
        {loadingFlows ? (
          <div style={{ textAlign: "center", padding: "32px 0", color: "#6366f1" }}>
            Loading flows…
          </div>
        ) : manualFlows.length === 0 ? (
          <div style={{ textAlign: "center", padding: "32px 0", color: "#9ca3af" }}>
            <ThunderboltOutlined style={{ fontSize: 32, marginBottom: 12, display: "block" }} />
            No active flows with manual trigger found.
            <br />
            <span style={{ fontSize: 12 }}>
              Create a flow and set its trigger to "Manual trigger".
            </span>
          </div>
        ) : (
          <List
            dataSource={manualFlows}
            renderItem={(flow) => (
              <List.Item
                style={{
                  cursor: triggeringFlowId ? "not-allowed" : "pointer",
                  padding: "10px 12px",
                  borderRadius: 8,
                  marginBottom: 4,
                  background: triggeringFlowId === flow._id ? "#f0f0ff" : "transparent",
                  transition: "background 0.15s",
                }}
                onClick={() => !triggeringFlowId && triggerFlow(flow._id)}
                onMouseEnter={(e) => { if (!triggeringFlowId) e.currentTarget.style.background = "#f5f3ff"; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = triggeringFlowId === flow._id ? "#f0f0ff" : "transparent"; }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 10, width: "100%" }}>
                  <ThunderboltOutlined style={{ color: "#6366f1", fontSize: 18 }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 13 }}>{flow.name}</div>
                    {flow.description && (
                      <div style={{ fontSize: 11, color: "#6b7280" }}>{flow.description}</div>
                    )}
                  </div>
                  {triggeringFlowId === flow._id && (
                    <span style={{ fontSize: 11, color: "#6366f1" }}>Starting…</span>
                  )}
                </div>
              </List.Item>
            )}
          />
        )}
      </Modal>
    </>
  );
};

export default MessageInput;
